// src/components/configs/headerConfigs.js
import { 
  School, Users, Calendar, Bell, FileText, Image, Phone, Award, BookOpen, User, Building2
} from 'lucide-react';

export const HEADER_CONFIGS = {
  album: {
    showUserProfile: true,
    showDashboardReturn: true,
    showDescription: true,
    showShare: true,
    logoHeight: 40,
    minHeight: 80,
    layout: 'simple'
  },

  ecommerce: {
    showUserProfile: true,
    showSearch: true,
    showCart: true,
    showWishlist: true,
    showContact: true,
    showShare: true,
    showFilters: true,
    searchPlaceholder: "Search products...",
    logoHeight: 40,
    minHeight: 80,
    layout: 'commerce'
  },

  institution: {
    showUserProfile: true,
    showNavigation: true,
    showShare: true,
    showContact: true,
    logoHeight: 60,
    minHeight: 80,
    layout: 'navigation',
    navigationItems: [
      { id: 'hero', label: 'Home', icon: School },
      { id: 'about', label: 'About', icon: FileText },
      { id: 'leadership', label: 'Leadership', icon: Users },
      { id: 'programs', label: 'Programs', icon: BookOpen },
      { id: 'events', label: 'Events', icon: Calendar },
      { id: 'news', label: 'News', icon: Bell },
      { id: 'resources', label: 'Resources', icon: FileText },
      { id: 'galleries', label: 'Gallery', icon: Image },
      { id: 'facilities', label: 'Facilities', icon: Building2 },
      { id: 'admissions', label: 'Admissions', icon: User },
      { id: 'contact', label: 'Contact', icon: Phone }
    ]
  },

  catalog: {
    showUserProfile: true,
    showSearch: true,
    showFilters: true,
    showShare: true,
    searchPlaceholder: "Search catalog...",
    logoHeight: 40,
    minHeight: 80,
    layout: 'catalog'
  },

  profile: {
    showUserProfile: true,
    showShare: true,
    showDescription: false,
    logoHeight: 40,
    minHeight: 80,
    layout: 'profile'
  }
};

// Helper function to get header config for a template
export const getHeaderConfig = (templateType, customConfig = {}) => {
  const baseConfig = HEADER_CONFIGS[templateType] || HEADER_CONFIGS.album;
  return { ...baseConfig, ...customConfig };
};